const DocumentLoader = ({ width = '24px', height = '24px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14,4.5H10.5a2,2,0,0,0-2,2v35a2,2,0,0,0,2,2h27a2,2,0,0,0,2-2V6.5a2,2,0,0,0-2-2H24" />
      <path d="M12,4.5l1.4142-1.4142A2,2,0,0,1,14.8284,2.5H23a1,1,0,0,1,1,1v25l-5-5-5,5V4.5" />
      <line x1="14" y1="38" x2="34" y2="38" />
      <line x1="24" y1="10" x2="34" y2="10" />
      <line x1="24" y1="17" x2="34" y2="17" />
      <line x1="24" y1="24" x2="34" y2="24" />
      <line x1="14" y1="31" x2="34" y2="31" />
    </svg>
  );
};

export default DocumentLoader;
